import { API } from 'aws-amplify'
import { fetchUserDesignation } from '../utils/meta'
import { hierarchyDetails } from '../../assets/offlineData/hierarchyData'

export const getMRs = (searchString, pageNumber, perPage, selectedHierarchy) => {
  const loggedInUserDesignation = fetchUserDesignation()

  if (loggedInUserDesignation === 'ae') {
    return API.get('baseURL', '/ae/meter-readers', {
      queryStringParameters: {
        ...(searchString && { mrCode: searchString.trim() }),
        page: pageNumber,
        perPage
      }
    })
  }
  if (selectedHierarchy === 'All') {
    return API.get('baseURL', `/${loggedInUserDesignation}/user`, {
      queryStringParameters: {
        ...(searchString && {
          mrCode: searchString.trim()
        }),
        userType: 'MR',
        page: pageNumber,
        perPage
      }
    })
  }

  const selectedUserAreaCode = hierarchyDetails.find(
    (item) => item.designation === selectedHierarchy.userType.toLowerCase()
  ).location.areaCode
  return API.get('baseURL', `/${loggedInUserDesignation}/user`, {
    queryStringParameters: {
      ...(searchString && {
        mrCode: searchString.trim()
      }),
      userType: selectedHierarchy.userType,
      secondLevelUserType: 'MR',
      userLocationCode: selectedHierarchy.location[selectedUserAreaCode],
      page: pageNumber,
      perPage
    }
  })
}

export const updateMR = (id, body) => {
  return API.patch('baseURL', `/ae/meter-readers/${id}`, {
    body
  })
}

export const downloadMRs = (searchString, selectedHierarchy) => {
  const loggedInUserDesignation = fetchUserDesignation()

  if (loggedInUserDesignation === 'ae') {
    return API.get('baseURL', '/ae/export-user', {
      queryStringParameters: {
        ...(searchString && { mrCode: searchString.trim() })
      }
    })
  }
  if (selectedHierarchy === 'All') {
    return API.get('baseURL', `/${loggedInUserDesignation}/export-user`, {
      queryStringParameters: {
        ...(searchString && {
          mrCode: searchString.trim()
        }),
        userType: 'MR'
      }
    })
  }

  const selectedUserAreaCode = hierarchyDetails.find(
    (item) => item.designation === selectedHierarchy.userType.toLowerCase()
  ).location.areaCode
  return API.get('baseURL', `/${loggedInUserDesignation}/export-user`, {
    queryStringParameters: {
      ...(searchString && {
        mrCode: searchString.trim()
      }),
      userType: selectedHierarchy.userType,
      secondLevelUserType: 'MR',
      userLocationCode: selectedHierarchy.location[selectedUserAreaCode]
    }
  })
}
